/****************************************************
 * Module Name:  addKeytosymbolModal.js
 * Project:      Pansuriya Impex Sales & Manufacturing
 * Owner:        info@pansuriyaimpex.com
 *
 * Copyright (c) Pansuriya Impex
 * All rights reserved.
 ****************************************************/
import React, { Component } from "react";
import { Form } from "react-bootstrap";
import Modal from "react-bootstrap/Modal";
import KeytosymbolProxy from "../../utility/proxy/manager/keytosymbolProxy";
import Constants from "../../utility/constants";
import CircularProgress from "@mui/material/CircularProgress";
import "bootstrap/dist/css/bootstrap.min.css";
import { Box, Button, TextField } from "@mui/material";
import Utility from "../../utility/utility";
import CommonSnackbar from "../common/commonSnackBar";
import { LoadingButton } from "@mui/lab";
import logo from '../../images/pansuriya.jpg'
import SaveIcon from '@mui/icons-material/Save';

export default class AddKeytosymbolModal extends Component {
  constructor(props) {
    super(props);

    this.state = {
      newkeytosymbol: this.props.editOperation
        ? this.props.sourceData.name
        : "",
      newkeytosymbolfullname: this.props.editOperation
        ? this.props.sourceData.fullname
        : "",
      newdescription: this.props.editOperation
        ? this.props.sourceData.description
        : "",
      newimage: this.props.editOperation ? this.props.sourceData.image : "",

      showError: false,

      validateKeytosymbolPresentSpinner: false,
      showValidationMessage: false,
      keytosymbolAvailable: true,

      keytosymbolValidationError: "",
      fullNameValidationError: "",
    };
  }

  handleSave = () => {
    let data = {
      id: this.props.editOperation ? this.props.sourceData.id : undefined,
      name: this.state.newkeytosymbol,
      fullname: this.state.newkeytosymbolfullname,
      description: this.state.newdescription,
      image: this.state.newimage,
    };

    if (this.props.handleSave) {
      if (this.props.handleValidation) {
        if (this.props.handleValidation(data)) this.props.handleSave(data);
        else
          this.setState({
            showError: true,
          });
      } else this.props.handleSave(data);
    }
  };

  closeErrorDialog = () => {
    this.setState({
      showError: false,
    });
  };

  validateKeytosymbolPresent = (keytosymbolEntered) => {
    if (!keytosymbolEntered || keytosymbolEntered.trim() === "") return;

    this.setState({
      validateKeytosymbolPresentSpinner: true,
    });

    KeytosymbolProxy.CheckKeytosymbolAvailable(
      keytosymbolEntered,
      (response) => {
        //if we got response that means keytosymbol is present at backend
        if (response) {
          //KeytosymbolName already present
          this.setState({
            validateKeytosymbolPresentSpinner: false,
            showValidationMessage: true,
            keytosymbolAvailable: false,
          });
        } else {
          //KeytosymbolName not available, so can be used
          this.setState({
            validateKeytosymbolPresentSpinner: false,
            showValidationMessage: true,
            keytosymbolAvailable: true,
          });
        }
      }
    );
  };

  buttonDisable = () => {
    if (
      this.props.editOperation &&
      this.state.newkeytosymbolfullname.length === 0
    )
      return true;

    if (!this.props.editOperation)
      return (
        !this.state.showValidationMessage ||
        !this.state.keytosymbolAvailable ||
        this.state.newkeytosymbolfullname.length === 0
      );

    return false;
  };

  render() {
    return (
      <Box>
        <CommonSnackbar
          show={this.state.showError}
          message={
            <Box>
              Add key to symbol validation Failed
              <br /> Please enter complete data
            </Box>
          }
          variant={"error"}
          autoHide={false}
          handleClose={this.closeErrorDialog}
          title="Validation Failure"
        />

        <Modal backdrop="static" show={this.props.Show} onHide={this.props.handleClose} enforceFocus={false}>
          <Modal.Header closeButton>
            <Modal.Title>
              <img
                src={logo}
                height="40pt"
                width="40pt"
                alt={Constants.COMPANY_SITE}
              />
              &nbsp;&nbsp;
              {this.props.editOperation
                ? "Edit Key To Symbol"
                : "Add New Key To Symbol"}
            </Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <center>
              <table style={{ width: "100%" }}>
                <tbody>
                  {this.props.editOperation && (
                    <tr>
                      <td>
                        <Form.Label>Key to symbol Id</Form.Label>
                      </td>
                      <td>
                        <Form.Label>{this.props.sourceData.id}</Form.Label>
                      </td>
                    </tr>
                  )}
                  {this.props.editOperation && (
                    <tr>
                      <td>&nbsp;</td>
                    </tr>
                  )}
                  <tr>
                    <td>
                      <Form.Label>
                        Key to symbol <sup style={{ color: "red" }}>*</sup>
                      </Form.Label>
                    </td>
                    {this.props.editOperation ? (
                      <td>
                        <Form.Label>{this.state.newkeytosymbol}</Form.Label>
                      </td>
                    ) : (
                      <td>
                        <TextField
                          margin="normal"
                          fullWidth
                          size="small"
                          label="Key to symbol (required)"
                          placeholder="Enter Key to symbol"
                          value={this.state.newkeytosymbol}
                          autoFocus
                          onBlur={(e) =>
                            this.validateKeytosymbolPresent(
                              this.state.newkeytosymbol
                            )
                          }
                          onChange={(e) =>
                            this.setState({
                              newkeytosymbol: e.target.value,
                              showValidationMessage: false,
                              keytosymbolValidationError: Utility.CheckIsPresent(
                                e.target.value
                              )
                                ? ""
                                : "Keytosymbol Cannot be Empty",
                            })
                          }
                          helperText={this.state.keytosymbolValidationError}
                          error={
                            this.state.keytosymbolValidationError.length > 0
                          }
                        />
                      </td>
                    )}
                  </tr>
                  <tr>
                    <td></td>
                    <td>
                      {this.state.validateKeytosymbolPresentSpinner ? (
                        <CircularProgress size="1rem" />
                      ) : !this.state.showValidationMessage ? (
                        <Box>&nbsp;</Box>
                      ) : this.state.keytosymbolAvailable ? (
                        <font color="green">Key to symbol available</font>
                      ) : (
                        <font color="red">Key to symbol not available</font>
                      )}
                    </td>
                  </tr>
                  <tr>
                    <td>
                      <Form.Label>
                        Fullname <sup style={{ color: "red" }}>*</sup>
                      </Form.Label>
                    </td>
                    <td>
                      <TextField
                        margin="normal"
                        fullWidth
                        size="small"
                        label="Key to symbol Fullname (required)"
                        placeholder="Enter key to symbol Fullname"
                        value={this.state.newkeytosymbolfullname}
                        onChange={(e) =>
                          this.setState({
                            newkeytosymbolfullname: e.target.value,
                            fullNameValidationError: Utility.CheckIsPresent(
                              e.target.value
                            )
                              ? ""
                              : "key to symbol Fullname Cannot be Empty",
                          })
                        }
                        helperText={this.state.fullNameValidationError}
                        error={this.state.fullNameValidationError.length > 0}
                      />
                    </td>
                  </tr>
                  <tr>
                    <td>
                      <Form.Label>Description</Form.Label>
                    </td>
                    <td>
                      <TextField
                        margin="normal"
                        fullWidth
                        size="small"
                        label="Description"
                        placeholder="Enter Description"
                        value={this.state.newdescription}
                        onChange={(e) =>
                          this.setState({ newdescription: e.target.value })
                        }
                      />
                    </td>
                  </tr>
                  <tr>
                    <td>&nbsp;</td>
                  </tr>
                  <tr>
                    <td>
                      <Form.Label>Image</Form.Label>
                    </td>
                    <td>
                      <table>
                        <tr>
                          <td >
                            <img
                              src={`data:image/png;base64, ${this.state.newimage}`}
                              alt=""
                              style={{ maxWidth: "60pt" }}
                            />
                          </td>
                          <td>
                            <input
                              type="file"
                              onChange={(e) => {
                                var fileD = new Blob([e.target.files[0]]);
                                var reader = new FileReader();
                                reader.onload = () => {
                                  var bytes = new Uint8Array(reader.result);
                                  this.setState({
                                    newimage: Array.from(bytes),
                                  });
                                };
                                reader.readAsArrayBuffer(fileD);
                              }}
                            />
                          </td>
                        </tr>
                      </table>
                    </td>
                  </tr>
                </tbody>
              </table>
            </center>
          </Modal.Body>
          <Modal.Footer>
            <LoadingButton
              loading={this.props.loading}
              loadingPosition="start"
              startIcon={<SaveIcon />}
              variant="contained"
              onClick={() => this.handleSave()}
              disabled={this.buttonDisable()}
              sx={{ mr: 1 }}
            >
              Save
            </LoadingButton>
            <Button
              variant="contained"
              color="error"
              onClick={this.props.handleClose}
              disabled={this.props.loading}
            >
              Close
            </Button>
          </Modal.Footer>
        </Modal>
      </Box>
    );
  }
}
